import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Section.css';
export default function Section({ headline, children, className, type }) {
    return (React.createElement("section", { "data-qa": `search-suggestions-section-${type}`, className: cx(styles.section, className) },
        headline ? React.createElement("h2", { className: styles.headline }, headline) : null,
        children));
}
Section.propTypes = {
    type: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    headline: PropTypes.string,
    className: PropTypes.string,
};
//# sourceMappingURL=Section.js.map